export function availabilityThreshold(items: number[], threshold: number | false = false): number | false {
  if (threshold !== false && items.some((available) => available < threshold)) {
    return threshold
  }

  return false
}
